import React, { useEffect } from 'react';
import { useState } from 'react';
import { useData } from '../../contexts/useData';

import {
  ComposableMap,
  Geographies,
  Geography,
  ZoomableGroup,
} from 'react-simple-maps';

import { darken, lighten } from '@mui/material';
import useSWR from 'swr';

import Tooltip from '@mui/material/Tooltip';
import { generateRandomNumber } from '../../utils/utils';

// export const MapVlaanderenSelectie = ({ setTooltipContent }) => {
//   const {
//     selectedGemeente,
//     setSelectedGemeente,
//     colors,
//     getVisibilityModel,
//     columnVisibilityModel,
//     setColumnVisibilityModel,
//     blobUrlGeo,
//   } = useData();

//   const [zoom, setZoom] = useState(1);
//   const [center, setCenter] = useState([0, 0]);

//   const updateColumnVisibilityModel = (label) => {
//     const hasField = columnVisibilityModel.hasOwnProperty(
//       selectedGemeente.label,
//     );

//     const { [selectedGemeente.label]: toRemove, ...newModel } =
//       columnVisibilityModel;

//     if (hasField && columnVisibilityModel[selectedGemeente.label] === false)
//       newModel[label] = false;

//     setColumnVisibilityModel(newModel);
//   };

//   const handleGeographyClick =
//     (geography: any, projection: any, path: any) => (event) => {
//       const centroid = projection.invert(path.centroid(geography));
//       setCenter(centroid);
//       setZoom(3);

//       //   TODO: update label to gemeente naam
//       const tmp = {
//         id: parseInt(geography.properties.n),
//         label: geography.properties.c,
//       };
//       updateColumnVisibilityModel(geography.properties.c);
//       setSelectedGemeente(tmp);
//     };
//   return (
//     <ComposableMap
//       projection="geoAlbers"
//       height={300}
//       projectionConfig={{
//         rotate: [-4.668, 0],
//         center: [-0.43, 51.09],
//         scale: 21000,
//       }}
//       // style={{ border: `1px solid ${colors[0]}` }}
//     >
//       {/* <ZoomableGroup center={center} zoom={zoom}> */}
//       <Geographies geography={geoData} style={{ cursor: 'pointer' }}>
//         {({ geographies, projection, path }) =>
//           geographies
//             // .filter((d) => parseInt(d.properties.n) === selectedGemeente.id)
//             .map((geo: any, idx: any) => {
//               // const cur = selectedBenchmarks.find(
//               const cur = [selectedGemeente].find(
//                 (s) => s.id === parseInt(geo.properties.n),
//               );
//               return (
//                 // <Console log={geo.properties.n} />
//                 <Tooltip
//                   title={
//                     <div style={{ fontSize: '1.2rem' }}>{geo.properties.c}</div>
//                   }
//                   arrow
//                   disableInteractive
//                   key={idx}
//                 >
//                   <Geography
//                     key={geo.rsmKey}
//                     geography={geo}
//                     fill={cur ? darken(colors[0], 0.1) : darken(colors[2], 0.3)}
//                     stroke={darken(colors[2], 0.45)}
//                     strokeWidth={1}
//                     // style={{
//                     //   default: { outline: 'none' },
//                     //   hover: { outline: 'none' },
//                     //   pressed: { outline: 'none' },
//                     // }}
//                     style={{
//                       default: {
//                         // fill: '#D6D6DA',
//                         outline: 'none',
//                       },
//                       hover: {
//                         fill: '#F53',
//                         outline: 'none',
//                       },
//                       pressed: {
//                         fill: '#E42',
//                         outline: 'none',
//                       },
//                     }}
//                     className="my-anchor-element"
//                     onClick={handleGeographyClick(geo, projection, path)}
//                     // onClick={() => {

//                     //   TODO: update label to gemeente naam
//                     //   const tmp = {
//                     //     id: parseInt(geo.properties.n),
//                     //     label: geo.properties.c,
//                     //   };
//                     //   setSelectedGemeente(tmp);
//                     // }}
//                   />
//                 </Tooltip>
//               );
//             })
//         }
//       </Geographies>
//       {/* </ZoomableGroup> */}
//     </ComposableMap>
//   );
// };

export const MapVlaanderenDetails = ({ data, selectedCluster }) => {
  const {
    selectedGemeente,
    selectedBenchmarks,
    clusterColors,
    highlightedGemeenteId,
    blobUrlGeo,
  } = useData();

  const colors = clusterColors;

  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {};

  const { data: geoData } = useSWR(
    `${blobUrlGeo}gemeenten_2025.json`,
    fetcher,
    swrOptions,
  );

  if (geoData) {
    return (
      <ComposableMap
        projection="geoAlbers"
        height={300}
        projectionConfig={{
          rotate: [-4.668, 0],
          center: [-0.43, 51.09],
          scale: 21000,
        }}
      >
        {/* <ZoomableGroup center={center} zoom={zoom}> */}
        <Geographies geography={geoData} style={{ cursor: 'pointer' }}>
          {({ geographies, projection, path }) =>
            geographies
              // .filter((d) => parseInt(d.properties.n) === selectedGemeente.id)
              .map((geo: any, idx: any) => {
                const gemeente = [selectedGemeente].find(
                  (s) => s.id === parseInt(geo.properties.n),
                );

                const bench = [selectedBenchmarks[0]].find(
                  (s) => s.id === parseInt(geo.properties.n),
                );

                // onClick of a shape
                const highlighted =
                  parseInt(highlightedGemeenteId) ===
                  parseInt(geo.properties.n);

                const filteredData = data.filter(
                  (s) => s.idRuimte === parseInt(geo.properties.n),
                );

                const cluster = filteredData.filter(
                  (s) => parseInt(selectedCluster) === parseInt(s.idCluster),
                );

                return (
                  // <Console log={geo.properties.n} />
                  <Tooltip
                    enterTouchDelay={0}
                    title={
                      <>
                        <div style={{ fontSize: '1.2rem' }}>
                          <p style={{ padding: '1rem' }}>{geo.properties.c}</p>
                          <p style={{ padding: '1rem', paddingTop: 0 }}>
                            {filteredData !== undefined &&
                              filteredData.length > 0 &&
                              filteredData[0].clusterDescShort}
                          </p>
                        </div>
                      </>
                    }
                    arrow
                    disableInteractive
                    key={idx}
                  >
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={
                        cluster.length > 0
                          ? bench
                            ? colors[2]
                            : gemeente
                            ? colors[1]
                            : colors[0]
                          : '#fff'
                      }
                      opacity={gemeente || bench ? 1 : 1}
                      stroke={cluster.length > 0 ? '#ddd' : '#ddd'}
                      strokeWidth={cluster.length > 0 ? 1 : 1}
                      style={{
                        default: {
                          outline: 'none',
                        },
                        hover: {
                          fill: colors[1],
                          opacity: 1,
                          outline: 'none',
                        },
                        pressed: {
                          fill: colors[1],
                          opacity: 1,
                          outline: 'none',
                        },
                      }}
                      className="my-anchor-element"
                    />
                  </Tooltip>
                );
              })
          }
        </Geographies>
        {/* </ZoomableGroup> */}
      </ComposableMap>
    );
  } else {
    return <div>Fout bij het laden van de data</div>;
  }
};

export const MapVlaanderenInteractieve = ({ data }) => {
  const { clusterColorsInteractieve, blobUrlGeo } = useData();

  const colors = clusterColorsInteractieve;
  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {
    // revalidateOnFocus: false,
    // revalidateOnMount: false,
    // revalidateOnReconnect: false,
    // refreshWhenOffline: false,
    // refreshWhenHidden: false,
    // refreshInterval: 0,
  };

  const { data: geoData } = useSWR(
    `${blobUrlGeo}gemeenten_2025.json`,
    fetcher,
    swrOptions,
  );

  if (geoData) {
    return (
      <ComposableMap
        projection="geoAlbers"
        height={300}
        projectionConfig={{
          rotate: [-4.668, 0],
          center: [-0.43, 51.09],
          scale: 21000,
        }}
      >
        {/* <ZoomableGroup center={center} zoom={zoom}> */}
        <Geographies geography={geoData} style={{ cursor: 'pointer' }}>
          {({ geographies, projection, path }) =>
            geographies
              // .filter((d) => parseInt(d.properties.n) === selectedGemeente.id)
              .map((geo: any, idx: any) => {
                const filteredData = data.filter(
                  (s) => s.idRuimte === parseInt(geo.properties.n),
                );

                return (
                  // <Console log={geo.properties.n} />
                  <Tooltip
                    enterTouchDelay={0}
                    title={
                      <>
                        <div style={{ display: 'inline-block' }}>
                          <p style={{ padding: '1rem' }}>
                            {geo.properties.c}:{' '}
                            {filteredData !== undefined &&
                            filteredData.length > 0
                              ? filteredData[0].formattedValue
                              : 'geen data'}
                          </p>
                        </div>
                      </>
                    }
                    //  arrow
                    disableInteractive
                    key={idx}
                  >
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={
                        filteredData && filteredData.length > 0
                          ? colors[filteredData[0].clusterNummer - 1]
                          : '#fff'
                      }
                      opacity={1}
                      stroke={'#888'}
                      strokeWidth={1}
                      style={{
                        default: {
                          // fill: '#D6D6DA',
                          outline: 'none',
                        },
                        hover: {
                          fill: colors[5],
                          opacity: 1,
                          outline: 'none',
                        },
                        pressed: {
                          fill: colors[5],
                          opacity: 1,
                          outline: 'none',
                        },
                      }}
                      className="my-anchor-element"
                    />
                  </Tooltip>
                );
              })
          }
        </Geographies>
        {/* </ZoomableGroup> */}
      </ComposableMap>
    );
  } else {
    return <div>Fout bij het laden van de data</div>;
  }
};

export const MapVlaanderenInteractieveMobile = ({ data }) => {
  const { clusterColorsInteractieve, blobUrlGeo } = useData();

  const colors = clusterColorsInteractieve;
  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {
    // revalidateOnFocus: false,
    // revalidateOnMount: false,
    // revalidateOnReconnect: false,
    // refreshWhenOffline: false,
    // refreshWhenHidden: false,
    // refreshInterval: 0,
  };

  const { data: geoData } = useSWR(
    `${blobUrlGeo}gemeenten_2025.json`,
    fetcher,
    swrOptions,
  );

  if (geoData) {
    return (
      <ComposableMap
        projection="geoAlbers"
        height={300}
        projectionConfig={{
          rotate: [-4.668, 0],
          center: [-0.43, 51.09],
          scale: 21000,
        }}
      >
        {/* <ZoomableGroup center={center} zoom={zoom}> */}
        <Geographies geography={geoData} style={{ cursor: 'pointer' }}>
          {({ geographies, projection, path }) =>
            geographies
              // .filter((d) => parseInt(d.properties.n) === selectedGemeente.id)
              .map((geo: any, idx: any) => {
                const filteredData = data.filter(
                  (s) => s.idRuimte === parseInt(geo.properties.n),
                );

                return (
                  // <Console log={geo.properties.n} />
                  <Tooltip
                    enterTouchDelay={0}
                    title={
                      <>
                        <div style={{ display: 'inline-block' }}>
                          <p style={{ padding: '1rem' }}>
                            {geo.properties.c}:{' '}
                            {filteredData !== undefined &&
                            filteredData.length > 0
                              ? filteredData[0].formattedValue
                              : 'geen data'}
                          </p>
                        </div>
                      </>
                    }
                    //  arrow
                    disableInteractive
                    key={idx}
                  >
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={
                        filteredData && filteredData.length > 0
                          ? colors[filteredData[0].clusterNummer - 1]
                          : '#fff'
                      }
                      opacity={1}
                      stroke={'#888'}
                      strokeWidth={1}
                      style={{
                        default: {
                          // fill: '#D6D6DA',
                          outline: 'none',
                        },
                        hover: {
                          fill: colors[5],
                          opacity: 1,
                          outline: 'none',
                        },
                        pressed: {
                          fill: colors[5],
                          opacity: 1,
                          outline: 'none',
                        },
                      }}
                      className="my-anchor-element"
                    />
                  </Tooltip>
                );
              })
          }
        </Geographies>
        {/* </ZoomableGroup> */}
      </ComposableMap>
    );
  } else {
    return <div>Fout bij het laden van de data</div>;
  }
};

export const MapVlaanderenInsights = ({
  data,
  selectedCluster,
  setSelectedCluster,
}) => {
  const {
    selectedGemeente,
    selectedBenchmarks,
    clusterColors,
    highlightedGemeenteId,
    blobUrlGeo,
  } = useData();

  const colors = clusterColors;

  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {};

  const { data: geoData } = useSWR(
    `${blobUrlGeo}gemeenten_2025.json`,
    fetcher,
    swrOptions,
  );

  if (geoData) {
    return (
      <ComposableMap
        projection="geoAlbers"
        height={300}
        projectionConfig={{
          rotate: [-4.668, 0],
          center: [-0.43, 51.09],
          scale: 21000,
        }}
      >
        {/* <ZoomableGroup center={center} zoom={zoom}> */}
        <Geographies geography={geoData} style={{ cursor: 'pointer' }}>
          {({ geographies, projection, path }) =>
            geographies
              // .filter((d: any) => parseInt(d.properties.NISCODE) === 11002)
              .map((geo: any, idx: any) => {
                const gemeente = [selectedGemeente].find(
                  (s) => s.id === parseInt(geo.properties.n),
                );

                const bench = [selectedBenchmarks[0]].find(
                  (s) => s.id === parseInt(geo.properties.n),
                );

                // onClick of a shape
                const highlighted =
                  parseInt(highlightedGemeenteId) ===
                  parseInt(geo.properties.n);

                const filteredData = data.filter(
                  (s) => s.idRuimte === parseInt(geo.properties.n),
                );

                let cluster = filteredData.filter((s) => {
                  // console.log(s);
                  return parseInt(selectedCluster) === parseInt(s.idCluster);
                });

                if (selectedCluster === -1) {
                  cluster = filteredData;
                }

                return (
                  // <Console log={geo.properties.n} />
                  <Tooltip
                    enterTouchDelay={0}
                    title={
                      <>
                        <div style={{ fontSize: '1.2rem' }}>
                          <p style={{ padding: '1rem' }}>{geo.properties.c}</p>
                          <p style={{ padding: '1rem', paddingTop: 0 }}>
                            {filteredData !== undefined &&
                              filteredData.length > 0 &&
                              filteredData[0].clusterDescShort}
                          </p>
                        </div>
                      </>
                    }
                    arrow
                    disableInteractive
                    key={idx}
                  >
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={
                        filteredData !== undefined &&
                        filteredData.length > 0 &&
                        filteredData[0].color
                      }
                      fillOpacity={
                        cluster !== undefined && cluster.length > 0 ? 1 : 0.1
                      }
                      stroke={cluster.length > 0 ? '#ddd' : '#ddd'}
                      strokeWidth={cluster.length > 0 ? 1 : 1}
                      style={{
                        default: {
                          outline: 'none',
                        },
                        hover: {
                          fill: colors[1],
                          opacity: 1,
                          outline: 'none',
                        },
                        pressed: {
                          fill: colors[1],
                          opacity: 1,
                          outline: 'none',
                        },
                      }}
                      className="my-anchor-element"
                    />
                  </Tooltip>
                );
              })
          }
        </Geographies>
        {/* </ZoomableGroup> */}
      </ComposableMap>
    );
  } else {
    return <div>Fout bij het laden van de data</div>;
  }
};
